import React from 'react';

import { useQuery } from 'react-query';
import { CartItemsService, CartMetaDataService } from 'services/payments';
import UseToast from 'hooks/use-toast';

import CartItem from './CartItem';
import CartDetails from './CartDetails';
import CartEmpty from './CartEmpty';
import Spinner from '@core/components/spinner/Spinner';

import { getAccessToken } from 'utils/authentication';

import ErrorSvg from 'assets/images/empty-search.svg';

import classes from './CartMain.module.scss';

const CartMain = () => {
	const { toast, ToastContainer } = UseToast();
	const {
		data: cartItems,
		refetch: refetchCart,
		isLoading,
		error
	} = useQuery(['cart-items', getAccessToken()], () => CartItemsService(), {
		onSuccess: () => {
			cartMetaData && refetchMetaData();
		}
	});

	const { data: cartMetaData, refetch: refetchMetaData } = useQuery(
		['cart-meta'],
		() => CartMetaDataService(),
		{ enabled: false }
	);
	return (
		<>
			<div className="container d-flex align-items-center justify-content-center my-1 my-md-5">
				{cartItems && !isLoading && !error ? (
					cartItems.data.length > 0 ? (
						<div className="col-12 col-xl-8">
							<div className={`${classes['cart-items-list']} w-100 d-flex flex-column col-12`}>
								{cartItems.data.map((item) => (
									<CartItem
										item={item}
										key={item.item_id}
										refetchCart={refetchCart}
										toast={toast}
									/>
								))}
							</div>
							<CartDetails refetchCart={refetchCart} />
						</div>
					) : (
						<CartEmpty />
					)
				) : isLoading && !error ? (
					<div className={classes['loading']}>
						<Spinner />
					</div>
				) : (
					<div
						className={`${classes['error']} d-flex flex-column align-items-center justify-content-center w-100`}>
						<ErrorSvg />
						<h1>Oh oh!</h1>
						<p>Something went wrong! please reload the page.</p>
					</div>
				)}
			</div>
			<ToastContainer />
		</>
	);
};

export default CartMain;
